import React from 'react';
import pt from 'prop-types';

import View from 'components/view';
import { Form } from 'components/form';
import { Section, SectionGroup } from 'components/section';
import Button from 'components/button';
import { confirmNewExperience } from 'components/dashboard-switch';

import PartnerProfileForm from 'components/partners/profile-form';
import DirectoryListingCard from './directory-listing-card';

import './settings.scss';

export default class ProfileSettings extends React.PureComponent {
  static contextTypes = {
    openModal: pt.func,
  };

  static propTypes = {
    values: pt.object,
    apps: pt.array,
    errors: pt.object,
    edited: pt.bool,
    onChangePartnerName: pt.func,
    onChangeForm: pt.func,
    onSubmitForm: pt.func,
    onFormRef: pt.func,
    listingStatus: pt.string,
    onClickListingAction: pt.func,
    onClickListingCriteria: pt.func,
  };

  onClickTryNewExperience = (event) => {
    event.preventDefault();
    confirmNewExperience(this.context.openModal);
  };

  render() {
    const {
      values,
      apps,
      edited,
      onSubmitForm,
      onChangeForm,
      onChangePartnerName,
      onFormRef,
      errors,
      listingStatus,
      onClickListingAction,
      onClickListingCriteria,
    } = this.props;
    const canSaveDirectly =
      listingStatus === 'not_listed' || listingStatus === 'rejected';

    return (
      <div className="settings settings-profile">
        <Form
          ref={onFormRef}
          onSubmit={onSubmitForm}
          onChange={onChangeForm}
          values={values}
        >
          <View
            full
            headerTitle="Partner page"
            headerActions={
              canSaveDirectly
                ? [
                    {
                      label: 'Save changes',
                      type: edited ? 'default' : 'secondary disabled',
                      submit: true,
                    },
                  ]
                : []
            }
          >
            <fieldset className="full">
              <DirectoryListingCard
                status={listingStatus}
                edited={edited}
                onClickAction={onClickListingAction}
                onClickCriteria={onClickListingCriteria}
              />
            </fieldset>

            <PartnerProfileForm
              values={values}
              apps={apps}
              errors={errors}
              listingStatus={listingStatus}
              onChangePartnerName={onChangePartnerName}
            />

            <SectionGroup>
              <Section
                title="New dashboard experience"
                subtitle="Try the new partner dashboard. It’s in beta and doesn’t support everything the classic dashboard does yet."
                actions={[
                  <Button
                    key="try-new-experience"
                    size="sm"
                    type="secondary"
                    onClick={this.onClickTryNewExperience}
                  >
                    Try the new experience
                  </Button>,
                ]}
              />
            </SectionGroup>
          </View>
        </Form>
      </div>
    );
  }
}
